import { PortableText } from "next-sanity";
import { PortableTextComponents } from "../portableText/PortableTextComponents";

export default function LinkText({ content, className }: { content: any; className?: string }) {
    return (
        <div className={className}>
            <PortableText value={content.textContent} components={PortableTextComponents} />
        </div>
    );
}
